"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExpandableColumn = void 0;
/* eslint-disable react/jsx-props-no-spreading */
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function useExpandableColumn(_a) {
    var expandable = _a.expandable, hideExpandColumn = _a.hideExpandColumn;
    return function (hooks) {
        if (!expandable || hideExpandColumn) {
            return;
        }
        hooks.visibleColumns.push(function (columns) { return __spreadArray([
            {
                id: 'expander',
                Cell: function (_a) {
                    var row = _a.row;
                    // Use the row.canExpand and row.getToggleRowExpandedProps prop getter
                    // to build the toggle for expanding a row
                    return row.canExpand ? (react_1.default.createElement("div", { style: { width: '100%', display: 'flex', justifyContent: 'center' } }, row.isExpanded ? react_1.default.createElement(core_ui_1.IconCaretSolid, null) : react_1.default.createElement(core_ui_1.IconCaretSolid, { rotate: -90 }))) : null;
                },
                maxWidth: 50,
                minWidth: 50,
                width: 50,
                disableSortBy: true,
                disableResizing: true,
            }
        ], columns, true); });
    };
}
exports.useExpandableColumn = useExpandableColumn;
